import React from "react";
import PropTypes from "prop-types";
import { Popover, Space, Select, Input } from "antd";

import QuarterlyMonth, { QuaterlyMonthChangeHandler } from "./QuarterlyMonth";
import YearlyMonth, { YearlyMonthChangeHandler } from "./YearlyMonth";
import LastDay from "./LastDay";
import DateOfMonth from "./DateOfMonth";
import WeekOfMonth, {
  weekSetValueHandler,
  daySetValueHandler,
} from "./WeekOfMonth";
import {
  getScheduleVal,
  getScheduleContent,
  QUARTERLY,
  MONTHLY,
  YEARLY,
} from "../../../utils/report";

const { Option } = Select;

const ScheduleElement = (props) => {
  const { record, updateMonthDateFn, updateField, invalidField } = props;
  let innerElement = null;
  switch (record.schedule_trigger_type) {
    case 1:
      innerElement = (
        <DateOfMonth
          value={getScheduleVal(record, 4)}
          onChange={updateMonthDateFn}
          reportType={record.shedule_type}
          month={getScheduleVal(record, 3)}
        >
          {[QUARTERLY, MONTHLY].includes(record.shedule_type) ? (
            <LastDay
              checked={getScheduleVal(record, 4) === "lastday"}
              onChange={updateMonthDateFn}
            />
          ) : null}
        </DateOfMonth>
      );
      break;
    case 2:
      innerElement = (
        <WeekOfMonth
          week={getScheduleVal(record, 1)}
          day={getScheduleVal(record, 2)}
          changeWeekHandler={(e) => {
            const setval = weekSetValueHandler(e.target.value, record);
            updateField(setval);
          }}
          changeDayHandler={(e) => {
            const setval = daySetValueHandler(e.target.value, record);
            updateField(setval);
          }}
        />
      );
      break;
    default:
      return (
        <Select
          placeholder="Please Select Schedule"
          value={record.schedule_weekday}
          status={invalidField ? "error" : ""}
          onChange={(e) => updateField( e)}
          style={{ width: "100%" }}
          allowClear
        >
          <Option value="Monday">Monday</Option>
          <Option value="Tuesday">Tuesday</Option>
          <Option value="Wednesday">Wednesday</Option>
          <Option value="Thursday">Thursday</Option>
          <Option value="Friday">Friday</Option>
          <Option value="Saturday">Saturday</Option>
          <Option value="Sunday">Sunday</Option>
        </Select>
      );
  }

  // TODO: need to re-factor
  // console.log(record,index,scheduletype)
  let monthselect = null;
  // define month select element
  switch (record.shedule_type) {
    case QUARTERLY:
      monthselect = (
        <QuarterlyMonth
          value={getScheduleVal(record, 3)}
          onChange={(e) => {
            const setvalue = QuaterlyMonthChangeHandler(e.target.value, record);
            updateField(setvalue);
          }}
        />
      );
      break;
    case YEARLY:
      monthselect = (
        <YearlyMonth
          value={getScheduleVal(record, 3)}
          onChange={(e) => {
            // console.log(e, 'change triggered')
            const setvalue = YearlyMonthChangeHandler(
              e,
              record,
              record.shedule_type,
            );
            updateField(setvalue);
          }}
        />
      );
      break;
    default:
      monthselect = null;
  }

  // define schedule input element
  let scheduleInput = null;
  if (
    record.schedule_trigger_type === 1 ||
    record.schedule_trigger_type === 2
  ) {
    scheduleInput = (
      <Input
        status={invalidField ? "error" : ""}
        placeholder="Please Select Schedule"
        value={getScheduleContent(record)}
      />
    );
  }

  return (
    <Popover
      content={
        <div>
          <Space direction="vertical">
            {monthselect}
            {innerElement}
          </Space>
        </div>
      }
      trigger="click"
    >
      {scheduleInput}
    </Popover>
  );
};

ScheduleElement.defaultProps = {
  invalidField: false,
};

ScheduleElement.propTypes = {
  record: PropTypes.shape({
    schedule_trigger_type: PropTypes.number,
    shedule_type: PropTypes.string.isRequired,
    schedule_weekday: PropTypes.string,
  }).isRequired,
  updateMonthDateFn: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired,
  invalidField: PropTypes.bool,
};

export default ScheduleElement;
